var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham-dark",style:({width: '100%', height: _vm.height + 'px'}),attrs:{"gridOptions":_vm.gridOptions,"rowData":_vm.records,"suppressRowClickSelection":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }